import { getActiveSchools, getTransfersHistory } from '@/api/transfer'
export default {
    state: {
        schools: {},
        history: []

    },

    mutations: {

        SET_ACTIVE_SCHOOLS: (state, data) => {
            state.schools = data
        },
        SET_TRANSFERS_HISTORY: (state, data) => {
            state.history = data
        }

    },

    actions: {
        getActiveSchools({ commit }, isInternalTransfer) {

            return new Promise((resolve, reject) => {
                getActiveSchools(isInternalTransfer).then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    var structure = {}
                    for (var i = 0; i < data.length; i++) {
                        var school = data[i];
                        if (!structure.hasOwnProperty(school.Ostan)) {
                            structure[school.Ostan] = {}
                        }
                        if (!structure[school.Ostan].hasOwnProperty(school.Shahr)) {
                            structure[school.Ostan][school.Shahr] = [];
                        }
                        structure[school.Ostan][school.Shahr].push(school)
                    }
                    commit('SET_ACTIVE_SCHOOLS', structure)

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getTransfersHistory({ commit }) {
            commit('SET_TABLE_TEXT', true)

            return new Promise((resolve, reject) => {
                getTransfersHistory().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;

                    commit('SET_TRANSFERS_HISTORY', data)
                    commit('SET_TABLE_TEXT', false)

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        }



    }
}